import React from "react";
import "./main.css";
import { createBrowserHistory } from "history";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import App from "./App";
import InnerPage from "./components/Detailpage/detailpage";
import Enquiry from "./components/Contact";
import Aboutus from "./components/aboutus";
import termsandconditions from "./components/termsandconditions";
import privacy from "./components/privacy";

const history = createBrowserHistory();

const Main = () => {
  // console.log(history);
  return (
    <Router history={history}>
      <Switch>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/`}
          component={App}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/destinationdetail/:destinationname/:packageid`}
          component={InnerPage}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/contact`}
          component={Enquiry}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/aboutus`}
          component={Aboutus}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/termsandconditions`}
          component={termsandconditions}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/privacy`}
          component={privacy}
        ></Route>
      </Switch>
    </Router>
  );
};

export default Main;
